import { render, staticRenderFns } from "./MainDashboard.vue?vue&type=template&id=0f1ef134&"
import script from "./MainDashboard.vue?vue&type=script&lang=js&"
export * from "./MainDashboard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports